// using CommonJS export because function is used in gatsby-node.js file and runs during node build
module.exports = {
  getLangsList: () => {
    return ['en', 'de', 'ja', 'fr', 'es-MX', 'pt-BR', 'ko', 'zh-CN', 'it', 'es']
  },
  getLangsCodes: () => {
    return {'en': 'en-us', 'de': 'de-de', 'ja': 'ja-jp', 'fr': 'fr-fr', 'es-MX': 'es-mx', 'pt-BR': 'pt-br', 'ko': 'ko-kr', 'zh-CN': 'zh-cn', 'it': 'it-it', 'es': 'es-es'}
  }
}